import { PTO_URL } from '@/api/pto/const'
import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { createBaseCRUDApi } from '@/api/base'

export const PTO_HANDBOOK_COST_PERSON_HOUR_URL = `${PTO_URL}/man-hour-cost`

const errors = createBaseResponseErrors('cтоимости чел./час', 'стоимостей чел./час')

export const PTOHandbookсostPersonHourApi = createBaseCRUDApi(PTO_HANDBOOK_COST_PERSON_HOUR_URL, errors)
